(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Coveo"), require("CoveoForSitecoreUserContext"));
	else if(typeof define === 'function' && define.amd)
		define(["Coveo", "CoveoForSitecoreUserContext"], factory);
	else if(typeof exports === 'object')
		exports["CoveoForSitecore"] = factory(require("Coveo"), require("CoveoForSitecoreUserContext"));
	else
		root["CoveoForSitecore"] = factory(root["Coveo"], root["CoveoForSitecoreUserContext"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_20__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition